export default "__VITE_ASSET__BFAtfhWe__"